"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _initResponseFileInfo = _interopRequireDefault(require("./init-response-file-info"));

var _initResponseFilePart = _interopRequireDefault(require("./init-response-file-part"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Represents information about a file as received from the direct binary upload initiate request.
 */
var InitResponseFile = /*#__PURE__*/function (_InitResponseFileInfo) {
  _inherits(InitResponseFile, _InitResponseFileInfo);

  var _super = _createSuper(InitResponseFile);

  /**
   * Constructs a new file instance using the provided information.
   *
   * @param {object} options Options controlling the overall process.
   * @param {DirectBinaryUploadOptions} uploadOptions Options controlling the upload process.
   * @param {UploadFile} uploadFile The original upload file from which the init data is based.
   * @param {object} fileData Raw file data as received from the init api.
   */
  function InitResponseFile(options, uploadOptions, uploadFile, fileData) {
    _classCallCheck(this, InitResponseFile);

    return _super.call(this, options, uploadOptions, uploadFile, fileData);
  }
  /**
   * Calculates and retrieves all the parts in which the file will be uploaded. This will be calculated
   * based on the number of URIs, the size of the file, and the file's getFilePartSize() value.
   *
   * @returns {Array} A list of InitResponseFilePart instances.
   */


  _createClass(InitResponseFile, [{
    key: "getParts",
    value: function getParts() {
      var parts = [];
      var uploadURIs = this.getUploadUris();
      var partSize = this.getFilePartSize();
      var fileSize = this.getFileSize();

      for (var index = 0; index < uploadURIs.length; index++) {
        var uploadUrl = uploadURIs[index];
        var start = index * partSize;
        var end = start + partSize;

        if (end > fileSize) {
          end = fileSize;
        }

        this.logDebug("Generate uploading part for file '".concat(this.getFileName(), "', index: '").concat(index, "', file range: '").concat(start, " - ").concat(end, "'"));
        parts.push(new _initResponseFilePart.default(this.getOptions(), this.getUploadOptions(), this.uploadFile, this.fileData, {
          start: start,
          end: end,
          url: uploadUrl
        }));
      }

      return parts;
    }
  }]);

  return InitResponseFile;
}(_initResponseFileInfo.default);

exports.default = InitResponseFile;